/** @format */

import {
  ChangeDetectionStrategy,
  Component,
  Input,
  PLATFORM_ID,
  computed,
  inject,
  input,
} from '@angular/core';

import { LoadingOverlayService } from '@shared/data-access/services';
import { isPlatformBrowser } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'common-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoadingOverlayComponent {
  private readonly loadingOverlayService = inject(LoadingOverlayService);
  private readonly platformId: object = inject(PLATFORM_ID);
  /**
   * @description Expands the coverage of the overlay component over it's parent component
   */
  @Input()
  public oversized = false;

  /**
   * @description Gives up control of when to show loading indicator instead of listening for changes to loadingOverlayService
   */
  manualControlEnabled = input(false);
  showLoading = input(false);
  overlayMessage = input('Loading, please wait.');

  private readonly serviceLoadingSignal = toSignal(this.loadingOverlayService.shouldShow, {
    initialValue: false,
  });

  showLoadingSignal = computed(() => {
    if (isPlatformBrowser(this.platformId) && !this.manualControlEnabled()) {
      return this.serviceLoadingSignal();
    }

    return this.showLoading();
  });
}
